module.exports = __webpack_public_path__ + "img/iso-toiture-terrasse.00f1d84e.svg";